import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Props for elements that behave like a link to a detail page but are not anchors
 * (kanban cards, table rows). Cmd/Ctrl+click and middle click open a new tab,
 * a plain click navigates inside the SPA.
 *
 * Returns a factory so it can be used for many rows rendered in a `.map()`.
 */
export function useDetailNavigation() {
  const navigate = useNavigate();

  return useCallback(
    (path: string) => ({
      onClick: (e: React.MouseEvent) => {
        if (e.metaKey || e.ctrlKey) {
          e.preventDefault();
          window.open(path, '_blank', 'noopener');
          return;
        }
        navigate(path);
      },
      // Middle click fires auxclick, not click
      onAuxClick: (e: React.MouseEvent) => {
        if (e.button !== 1) return;
        e.preventDefault();
        window.open(path, '_blank', 'noopener');
      },
      // Suppress the browser's middle-click autoscroll
      onMouseDown: (e: React.MouseEvent) => {
        if (e.button === 1) e.preventDefault();
      },
    }),
    [navigate],
  );
}
